import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getApp, initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyAWFzAfB08f1Lq8K0omqM0o4KeJgNCC9hU",
  authDomain: "padel-5s.firebaseapp.com",
  projectId: "padel-5s",
  storageBucket: "padel-5s.firebasestorage.app",
  messagingSenderId: "70606646192",
  appId: "1:70606646192:web:0db57d1662c78560b50477",
  measurementId: "G-4KJTRHK53Z"
};

// Get existing Firebase app or initialize a new one
let app;
try {
  app = getApp();
} catch (error) {
  // App doesn't exist, initialize it
  app = initializeApp(firebaseConfig);
}

const storage = getStorage(app);

/**
 * Upload an image file to Firebase Storage
 * @param {File|Blob} file - The image file to upload
 * @param {string} path - Storage path (e.g., 'avatars/player_123.jpg')
 * @returns {Promise<string>} - Download URL of the uploaded file
 */
export const uploadImage = async (file, path) => {
  if (!storage) {
    throw new Error('Firebase Storage is not initialized');
  }

  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file);
  const downloadURL = await getDownloadURL(storageRef);
  return downloadURL;
};

/**
 * Generate a unique path for avatar uploads
 * @param {string} type - 'player', 'club', or 'event'
 * @param {string} id - Unique identifier (player name, club ID, or event name)
 * @returns {string} - Storage path
 */
export const generateAvatarPath = (type, id) => {
  const timestamp = Date.now();
  const sanitizedId = id.replace(/[^a-zA-Z0-9]/g, '_');
  return `avatars/${type}/${sanitizedId}_${timestamp}.jpg`;
};

